import { get } from 'lodash';
import store from '../store/index';
import i18n from '@/js/vue-i18n';

const getFormattedDate = (translationKey, date, moment) => {
    const separator = get(store.state, 'clientConfig.i18nConfig.defaultDateSeparator');
    const dateFormat = i18n.t(translationKey, { separator });
    return i18n.d(dateFormat, date, moment);
};

const getFormattedWeekNumber = (prefix, week) => {
    return i18n.t(prefix).concat(String(week).padStart(2, '0'));
};

const getWeekNumberClient = week => {
    return getFormattedWeekNumber('general.dates.weekFirstLetter', week);
};

const getWeekNumberShorthandClient = week =>
    getFormattedWeekNumber('general.dates.weekShorthand', week);

const fullDateText = (moment, date) => i18n.d(`dates.default.fullDateText`, date, moment);
const weekNumberClient = (moment, date) => getWeekNumberClient(date);
const dateTime = (moment, date) => i18n.d(`dates.default.dateTime`, date, moment);
const localShortDate = (moment, date) => i18n.d(`dates.default.localShortDate`, date, moment);
const shortDate = (moment, date) => i18n.d(`dates.default.shortDate`, date, moment);
const weekNumberShorthand = (moment, date) =>
    i18n.eUTC('dates.default.weekNumberShorthand', date, moment);
const weekNumberShorthandClient = (moment, week) => getWeekNumberShorthandClient(week);
const weekNumber = (moment, date) => i18n.eUTC('dates.default.weekNumber', date, moment);
const dateShorthand = (moment, date) => i18n.eUTC('dates.default.dateShorthand', date, moment);
const dateShodateShorthandNoYearrthand = (moment, date) =>
    i18n.eUTC('dates.default.dateShorthandNoYear', date, moment);
const localDayMonth = (moment, date) =>
    getFormattedDate('dates.default.localDayMonth', date, moment);
const datepickerFormat = (moment, date) =>
    i18n.eUTC('dates.default.datepickerFormat', date, moment);
const datesInYear = (moment, date) => i18n.eUTC('dates.default.datesInYear', date, moment);
const timeStamp = (moment, date) => i18n.d('dates.default.timeStamp', date, moment);

export {
    fullDateText,
    weekNumberClient,
    dateTime,
    localShortDate,
    weekNumberShorthand,
    weekNumberShorthandClient,
    weekNumber,
    dateShorthand,
    dateShodateShorthandNoYearrthand,
    localDayMonth,
    datepickerFormat,
    datesInYear,
    timeStamp,
    shortDate,
};
